import { GROUP_FUNCTION_TYPE_FILTER_OPTIONS } from "./student.group.constant";

const getStaffGroupRouteQuery = () => {
  return {
    groupType: GROUP_FUNCTION_TYPE_FILTER_OPTIONS.STAFF.value,
  };
};

const getStudentGroupRouteQuery = () => {
  return {
    groupType: GROUP_FUNCTION_TYPE_FILTER_OPTIONS.STUDENT.value,
  };
};

const getProfessionalDevelopmentGroupRouteQuery = () => {
  return {
    groupType: GROUP_FUNCTION_TYPE_FILTER_OPTIONS.PROFESSIONAL_DEVELOPMENT.value,
  };
};

export default {
  getStaffGroupRouteQuery,
  getStudentGroupRouteQuery,
  getProfessionalDevelopmentGroupRouteQuery,
};
